import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Typography, Row, Col, Space } from "antd";
import { SettingOutlined, FilePdfOutlined } from "@ant-design/icons";
import "./Management.scss";
import LogoImageUploader from "../../Components/ProfileImageUploader/LogoImageUploader";
import OrderPdfDownloader from "../../Components/Management/OrderPdfDownloader";
import AgentAccountOverview from "./AgentAccountOverview";
import BankAccountDetailsCard from "./BankAccountDetailsCard";
import PublicSiteCommissionsSettings from "../../Components/Agent/SiteSettings/PublicSiteCommissionsSettings";

const { Title, Text } = Typography;

const Management = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("logo");

  const categories = [
    {
      key: "logo",
      title: "לוגו חברה",
      icon: <SettingOutlined style={{ fontSize: 22 }} />,
      description: "ניהול לוגו החברה",
      component: <LogoImageUploader />,
    },
    {
      key: "pdf-test",
      title: "הורדת שובר/אישור",
      icon: <FilePdfOutlined style={{ fontSize: 22 }} />,
      description: "הורדת שובר או אישור הזמנה לבדיקה",
      component: <OrderPdfDownloader />,
    },
  ];

  const handleCategoryClick = (category) => {
    if (category.isLink) {
      navigate(category.path);
    } else {
      setActiveCategory(category.key);
    }
  };

  const activeCategoryData = categories.find((cat) => cat.key === activeCategory);

  return (
    <div className="management-container">
      <Title level={1} style={{ marginBottom: 8 }}>
        אזור אישי
      </Title>
      <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
        מצב חשבון, מנוי וצוות — והגדרות נלוות
      </Text>

      <AgentAccountOverview />

      <BankAccountDetailsCard />

      <Title level={4} style={{ marginBottom: 12 }}>
        הגדרות
      </Title>
      <PublicSiteCommissionsSettings />

      <Row gutter={[12, 12]} style={{ marginBottom: 16 }} className="management-tools-row">
        {categories.map((category) => (
          <Col xs={24} sm={12} md={12} key={category.key}>
            <Card
              size="small"
              hoverable
              className={`category-card management-tools-card ${
                activeCategory === category.key ? "active" : ""
              }`}
              onClick={() => handleCategoryClick(category)}
              style={{
                cursor: "pointer",
                border:
                  activeCategory === category.key
                    ? "2px solid #1890ff"
                    : "1px solid #d9d9d9",
              }}
            >
              <Space align="start" size="middle">
                <span style={{ color: "#1890ff" }}>{category.icon}</span>
                <div>
                  <Title level={5} style={{ margin: 0 }}>
                    {category.title}
                  </Title>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {category.description}
                  </Text>
                </div>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>

      {activeCategoryData && !activeCategoryData.isLink && (
        <Card>
          <div style={{ marginBottom: 16 }}>
            <Title level={4} style={{ marginBottom: 8 }}>
              {activeCategoryData.title}
            </Title>
            {activeCategoryData.key === "logo" && (
              <div
                style={{
                  marginBottom: 12,
                  fontSize: "13px",
                  color: "#666",
                  lineHeight: "1.5",
                  padding: "10px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <strong>שימו לב:</strong> הלוגו שתעלו כאן יופיע בהצעות מחיר, סיכומי הזמנה וכל המסמכים
                שמייצרים עבור הלקוחות.
              </div>
            )}
          </div>
          {activeCategoryData.component}
        </Card>
      )}
    </div>
  );
};

export default Management;
